import { Stack, Theme } from '@mui/material';

import { Icon } from '@/components/Icon/Icon';

import {
  SuggestionButton,
  SuggestionsWrapper,
} from './UsernameSuggestions.styled';

interface UsernameSuggestionsProps {
  usernames: string[];
  onClick: (name: string) => void;
}

export function UsernameSuggestions({
  usernames,
  onClick,
}: UsernameSuggestionsProps) {
  return (
    <SuggestionsWrapper>
      {usernames.map(name => (
        <SuggestionButton
          key={name}
          variant="outlined"
          onClick={() => onClick(name)}
        >
          <Stack gap={0.5}>
            {name}
            <Icon
              name={'check-circle-outline'}
              size={16}
              color={(theme: Theme) => theme.palette.green[500]}
            />
          </Stack>
        </SuggestionButton>
      ))}
    </SuggestionsWrapper>
  );
}
